/**
 * @param {number} startTime
 * @param {object} doctorLocation
 * @param {object} state
 */
import url from 'url';
import cookie from 'js-cookie';

export default function getBookingUrl(startTime, doctorLocation, state) {
    const bookingHost = process.env.BOOKING_HOST || 'https://www.zocdoc.com';
    const professionalId = doctorLocation.professional.professional_id;
    const locationId = doctorLocation.location.location_id;
    const {
        isExistingPatient: repeatPatient,
        procedureId,
        directoryId,
        widget,
        insuranceCarrier,
        insurancePlan,
    } = state;

    let additionalParams = {};
    if (insuranceCarrier !== '-1') {
        additionalParams.insuranceCarrier = insuranceCarrier;
    }

    if (insurancePlan !== '-1') {
        additionalParams.insurancePlan = insurancePlan;
    }

    additionalParams = augmentParamsForIce(additionalParams);

    return url.format({
        pathname: `${bookingHost}/booking/start`,
        query: {
            startTime,
            professionalId,
            locationId,
            procedureId,
            repeatPatient,
            directoryId,
            widget,
            ...additionalParams,
        },
    });
}

function augmentParamsForIce(params = {}) {
    const iceCookie = cookie.get('iceRequestToken', { secure: true });
    if (iceCookie) {
        params.iceRequestToken = iceCookie;
    }
    return params;
}
